

import logodark from "../karuncup-dark.svg";
import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import Navbar from "../components/Navbar";
import NewsDetail from "../components/NewsDetial";



const SignlePage = () => {
  const navigate = useNavigate();


  return (
    <div className="App">
      <Navbar dir='./' />
      <NewsDetail />
    </div>
  );
};

export default SignlePage;
